export const makeNumberToMillionsString = (numberFormatter: (value: number, formatOptions?: Partial<Intl.NumberFormatOptions> | undefined) => string) => (number: number | undefined | null) => {
  if (number == null) {
    return null;
  }
  return `${numberFormatter(number / 1_000_000)} M`;
};
